import React from 'react';

export const SearchContext = React.createContext({
    text: null,
    listWidgets: [],
    updateWidgets: null,
    updateText: null
});